const C = require("../constants");
const initial_data = {open: false, waiter:{id:null, full_name:'',}};

function WaiterDialogReducer(state = initial_data, action) {
    switch (action.type) {
        case C.WAITER_DIALOG:
            return action.data;
        default:
            return state;
    }
}

export default WaiterDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/WaiterDialogReducer.js